module.exports = __webpack_public_path__ + "img/139.6.52b4adc5.png";